export default __webpack_public_path__ + "static/media/setion05_kv02.a60f69bf.png";